function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import renderTemplateImpl from '../renderTemplate';
import NativeAdTrackerImpl from '../NativeAdTracker';
import { galleryTemplate as galleryTemplateImpl } from './galleryTemplate';

var GalleryAdComponent = /*#__PURE__*/function () {
  function GalleryAdComponent() {
    var renderTemplate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : renderTemplateImpl;
    var NativeAdTracker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NativeAdTrackerImpl;
    var galleryTemplate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : galleryTemplateImpl;

    _classCallCheck(this, GalleryAdComponent);

    this.renderTemplate = renderTemplate;
    this.NativeAdTracker = NativeAdTracker;
    this.galleryTemplate = galleryTemplate;
  }

  _createClass(GalleryAdComponent, [{
    key: "render",
    value: function render(adContentJson, renderTarget) {
      var _this = this;

      return this.renderTemplate(renderTarget, adContentJson, this.galleryTemplate).then(function () {
        _this.trackThirdParty(adContentJson.trackers);
      });
    }
  }, {
    key: "trackThirdParty",
    value: function trackThirdParty(trackers) {
      this.NativeAdTracker.trackDownloadImpression(trackers);
    }
  }]);

  return GalleryAdComponent;
}();

export default GalleryAdComponent;
//# sourceMappingURL=GalleryAdComponent.js.map